'use strict';
var log = Math.log;
var LN2 = Math.LN2;

// `Math.log2` method
// https://tc39.es/ecma262/#sec-math.log2
// eslint-disable-next-line es/no-math-log2 -- safe
module.exports = Math.log2 || function log2(x) {
  return log(x) / LN2;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/math-log2.js
// module id = 223
// module chunks = 0